<template>
    <div class="grid">
        <div class="unit whole">
            <h1>Combined results</h1>
            <p class="lead">View pupil reading test question results combined and over time.</p>
        </div>
    </div>
    <ReportingCombinedResultsComp
        v-if="!(isLoading.groups || isLoading.teacher || isLoading.classes)"
        :teacher="teacher"
        :classes="classes"
        :groups="groups"
    />
    <v-overlay
        :model-value="isLoading.groups || isLoading.teacher || isLoading.classes"
        class="align-center justify-center"
    >
        <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';

definePage({ meta: { area: 'reporting' } });
const store = useTeacherStore();
store.fetchTeacher();
store.fetchClasses();
store.fetchGroups();
const { teacher, isLoading, classes, groups } = storeToRefs(store);
</script>
